export default [
  {
    path: '/activity/create/:id',
    name: 'create-activity',
    component: () => import('@/views/modules/skeleton/lms/CreateActivity.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Create Activity',
          active: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/activity/edit/:id',
    name: 'edit-activity',
    component: () => import('@/views/modules/skeleton/lms/CreateActivity.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Edit Activity',
          active: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/activity/view/:id',
    name: 'view-activity',
    component: () => import('@/views/modules/skeleton/lms/ViewActivity.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'View Activity',
          active: true,
          back: true,
        },
      ],
    },
  },
]
